import { Component, Input } from '@angular/core'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import {
  availableSignTypes,
  normalizeSelectedSignTypes,
  signTypesPropertyFilterKey,
} from 'src/app/shared/utils/property-filter.utils'

@Component({
  selector: 'app-sign-types-filter-data',
  templateUrl: './sign-types-filter-data.component.html',
  styleUrls: ['./sign-types-filter-data.component.scss'],
  standalone: false,
})
export class SignTypesFilterDataComponent {
  @Input() appPath!: AppPaths

  public signTypes = availableSignTypes
  public selectedSignTypes = new Set<string>()
  private readonly signTypesFilterKey = signTypesPropertyFilterKey

  constructor(private appState: AppStateService) {
    this.selectedSignTypes = new Set(normalizeSelectedSignTypes(this.appState.selectSignTypes()))
  }

  public get selectedCount(): number {
    return this.selectedSignTypes.size
  }

  public get totalCount(): number {
    return this.signTypes.length
  }

  public isSelected(signType: string): boolean {
    return this.selectedSignTypes.has(signType)
  }

  public toggleSignType(signType: string): void {
    if (this.selectedSignTypes.has(signType)) {
      if (this.selectedSignTypes.size === 1) {
        return
      }
      this.selectedSignTypes.delete(signType)
    } else {
      this.selectedSignTypes.add(signType)
    }

    this.updateQueryParameters()
  }

  public getChipIconName(signType: string): string {
    switch (signType) {
      case 'SPEED_LIMIT':
        return 'SPEED_LIMIT_50'
      case 'SPEED_LIMIT_END':
        return 'SPEED_LIMIT_END_50'
      case 'SPEED_LIMIT_ZONE':
        return 'SPEED_LIMIT_ZONE_30'
      case 'SPEED_LIMIT_ZONE_END':
        return 'SPEED_LIMIT_ZONE_END_30'
      default:
        return signType
    }
  }

  private updateQueryParameters(): void {
    if (!this.appPath) {
      throw new Error('app-sign-types-filter-data requires [appPath] to be provided by the view')
    }

    const selectedSignTypes = Array.from(this.selectedSignTypes)
    const normalizedSignTypes = normalizeSelectedSignTypes(selectedSignTypes)
    const signTypesValue =
      normalizedSignTypes.length === availableSignTypes.length
        ? undefined
        : normalizedSignTypes.join('|')

    const propertyFilters = this.appState.selectPropertyFilters()
    if (signTypesValue) {
      propertyFilters[this.signTypesFilterKey] = signTypesValue
    } else {
      delete propertyFilters[this.signTypesFilterKey]
    }

    const propertyFiltersSerialized = Object.entries(propertyFilters)
      .map(([key, value]) => `${key}=${value}`)
      .join(',')

    this.appState.setState(this.appPath, {
      propertyFilters: propertyFiltersSerialized || undefined,
    })
  }
}
